import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { RoutesWrapper } from "./routes/RoutesWrapper";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";

const ErrorFallback = () => (
  <div className="flex h-screen flex-col items-center justify-center gap-4 px-6 text-center">
    <h1 className="text-xl font-semibold text-gray-900">
      Something went wrong
    </h1>
    <p className="text-sm text-gray-500">
      An unexpected error occurred. Please reload the page — if the problem
      persists, contact support.
    </p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      className="rounded-md bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-700"
    >
      Reload
    </button>
  </div>
);

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <Router>
        <AuthProvider>
          <ThemeProvider>
            <RoutesWrapper />
          </ThemeProvider>
        </AuthProvider>
      </Router>
    </Sentry.ErrorBoundary>
  );
}

export default App;
